import React from 'react';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';

import Modal from './Modal';
import { PickerRow, NEEDS_UPDATE } from './AlertPicker';

import { AlertTypes } from '../constants';
import { T, DRILLS } from '../constants/tokens';

/**
 * "Run a drill": fire, lockdown, severe weather and evacuation.
 *
 * A drill runs the alert it practises on every device, but sends no red
 * alert texts and places no emergency call. It cannot start while a real
 * alert is in force, which the server refuses too, so then every row says so.
 * A drill whose alert the school's badges cannot show yet is listed but
 * cannot be chosen.
 */
export default function DrillPicker({ open, onClose, onSelect, pending = [], realAlertInForce = false }) {
  const rows = Object.keys(DRILLS)
    .filter((key) => AlertTypes[key] != null)
    .map((key) => ({ key, status: AlertTypes[key], ...DRILLS[key] }))
    .map((item) => {
      let reason;
      if (realAlertInForce) reason = 'Not while a real alert is in force';
      else if (pending.includes(item.status.getDashboardStatus())) reason = NEEDS_UPDATE;
      return { ...item, reason };
    });

  return (
    <Modal
      open={open}
      onClose={onClose}
      width={560}
      eyebrow='Drills'
      title='Run a drill'
      body='Every badge in the school shows the alert as it would for real. No red alert texts are sent and emergency services are not called. A real alert raised during the drill ends it.'
      actions={<Button variant='outlined' onClick={onClose}>Cancel</Button>}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
        {rows.map((item) => <PickerRow key={item.key} item={item} onSelect={onSelect} />)}
      </div>

      {realAlertInForce &&
        <div style={{ fontSize: 13, lineHeight: '18px', color: T.body, marginBottom: 8 }}>
          Clear the alert in force before starting a drill.
        </div>}

      {!realAlertInForce && rows.some((item) => item.reason === NEEDS_UPDATE) &&
        <div style={{ fontSize: 13, lineHeight: '18px', color: T.body, marginBottom: 8 }}>
          Drills marked as needing the badge update become available once this school&apos;s badges and hubs can show their colours.
        </div>}
    </Modal>
  );
}

DrillPicker.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  /** Names of alert types the school's badges cannot show yet. */
  pending: PropTypes.arrayOf(PropTypes.string),
  realAlertInForce: PropTypes.bool
};
